import { render, staticRenderFns } from "./OrgHomeIntakeLeads.vue?vue&type=template&id=7b0db307&scoped=true&"
import script from "./OrgHomeIntakeLeads.vue?vue&type=script&lang=js&"
export * from "./OrgHomeIntakeLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0db307",
  null
  
)

export default component.exports